import * as React from "react";

function WarningIcon(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="1em"
			height="1em"
			{...props}
		>
			<path
				fill="currentColor"
				d="M12 3.25a1.5 1.5 0 0 1 1.3.75l8.5 14.75A1.5 1.5 0 0 1 20.5 21h-17a1.5 1.5 0 0 1-1.3-2.25L10.7 4A1.5 1.5 0 0 1 12 3.25m0 5.25a1 1 0 0 0-1 1v5.75a1 1 0 1 0 2 0V9.5a1 1 0 0 0-1-1m0 10.25a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5"
			></path>
		</svg>
	);
}

export default WarningIcon;
